import axios from "axios";
import {toast} from "react-toastify";
import i18n from "./i18n";
import { fireGTMWafError } from "./components/Utils/GTM/GTMHelper";

const instance = axios.create({
    baseURL: '/rest/v1'
});


instance.interceptors.request.use(req => req);
instance.interceptors.response.use(res => res,error => {

	if(error.response.status === 403) {
        if(['/faq','/privacy','/conditions','/auth/link-account'].includes(window.location.pathname)){
            return null
        }else{
            return window.location.href = '/login'
        }
    }

    if(error.response.status === 405) {
		const apiPath = `${error.config.baseURL ?? ''}${error.config.url ?? ''}`;

        const wafMsg = () => (
            <div>
                <i className="fal fa-shield-alt"></i>&nbsp; {i18n.t('errors.waf_blocked')}
                <small style={{fontSize:'70%',fontWeight:'normal',lineHeight:1.15,display:'block',marginTop:'0.5rem'}}>
                    {i18n.t('errors.waf_blocked_detail')}
                </small>
            </div>);

        toast.error(wafMsg);

        fireGTMWafError(true, apiPath);

        return Promise.reject(error);
    }




	console.log('Error details',error);
    console.log('Error response body',error.response);

    const msg = () => (
        <div>
            <i className="fal fa-exclamation-circle"></i>&nbsp; An error occured
            <small style={{fontSize:'70%',fontWeight:'normal',lineHeight:1.15,display:'block',marginTop:'0.5rem'}}>
                {error.message}
            </small>
        </div>);

    if(error.response.status !== 404 && error.response.status !== 422) {
        toast.error(msg);
    }

    return Promise.reject(error);
});


export default instance
